export default () => ({
  recomendedPosts: [],
  //forYouPosts: [],
  suggestedPosts: [],
  recomendedPost: [],
  followingPosts: [],
  replies: [],
  reputationCategories: null,
  post: null,
  now: new Date(),
  profile: null,
  // Profile-by-username data for profile view
  usernameData: null,
  userReplies: [],
  userReposts: [],
  onlyUserPosts: [],
  loadStatus: false,
  // Global full-page loader state for route changes
  isRouteLoading: false,
  reportId: null,
  isReply: false,
  replyPostStatus: [],
  totalCountPosts: null,
  allFollowPosts: [],
  repliesCount: 0,
  searchText: '',
  searchResults: {
  users: [],
  posts: [],
  groups: [],
  },
  unreadPosts: [],
  noSearchResults: null,
  introPosts: [],
});
